import axios from "axios";
import createPublicApiInstance from '../api';

export async function loginUser(payload) {

	const originalResponse = await axios.post(`${process.env.REACT_APP_DANSUAPI}/public/prestador/login`, {	
		cuil_cuit: payload.user,
		password: payload.password,
	});

	//Reemplazamos la info del prestador por la que retorna Sisad.
	const apiInstance = createPublicApiInstance();
	if (!apiInstance) {
		throw new Error('API instance is not available');
	}

	const sisadaResult = await apiInstance.get(`/prestador/${originalResponse.data.user.prestador_id}?authToken=${originalResponse.data.access_token}`)
	originalResponse.data.user = sisadaResult.data;
	return originalResponse;
}